<template>
  <div>
    <!-- Admin Header -->
    <div v-if="userInfo && userInfo.user">
      <AdminHeader v-if="userInfo.user.permission == 'super_admin'" />
    </div>

    <div class="w-full">
      <div
        class="container mx-auto max-w-[1200px]"
        style="min-height: 70vh !important"
      >
        <!-- ================= LIST VIEW ================= -->
        <div class="my-6">
          <div class="flex items-center gap-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-6 h-6 text-indigo-500"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>

            <h1 class="text-xl font-bold text-blue-600">
              {{ student_email }}
            </h1>
          </div>
        </div>
        <div class="pb-10 px-6" v-if="notificationIndex == null">
          <div class="flex justify-between">
            <div class="flex items-center gap-3">
              <div class="font-bold text-xl text-gray-800">Notifications</div>
              <div
                v-if="notificationcount"
                class="bg-gradient-to-r from-blue-500 to-blue-600 flex items-center justify-center text-white min-w-[26px] h-[26px] text-xs font-bold rounded-full shadow-sm px-1.5"
              >
                {{ notificationcount }}
              </div>
            </div>
            <router-link
              :to="{ name: 'StudentList' }"
              class="inline-flex items-center gap-2 bg-gray-700 hover:bg-gray-800 text-white rounded-xl text-sm font-semibold px-5 py-2.5 transition-all duration-200 shadow-sm hover:shadow-md"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M10 19l-7-7m0 0l7-7m-7 7h18"
                />
              </svg>
              Back
            </router-link>
          </div>

          <div class="flex flex-col gap-2">
            <!-- Notification List -->
            <div v-if="notificationList.length != 0" class="mt-6 space-y-3">
              <div
                v-for="(notifi, index) in notificationList"
                :key="notifi.id"
                @click="setNotificationTab(index)"
                class="group transition-all duration-200"
              >
                <div
                  class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 p-5 rounded-2xl border bg-white shadow-sm hover:shadow-md cursor-pointer transition-all duration-200 hover:border-primary/30 hover:bg-gradient-to-r hover:from-white hover:to-primary/5"
                  :class="{
                    'border-l-4 border-l-blues': notifi.read !== true,
                    'border-gray-100': notifi.read === true,
                    'bg-primary/5': notifi.read !== true,
                  }"
                >
                  <div class="flex items-center gap-3 min-w-0">
                    <div class="flex-shrink-0 relative">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22ZM18 16V11C18 7.93 16.36 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.63 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16Z"
                          :fill="notifi.read !== true ? '#3B82F6' : '#9CA3AF'"
                        />
                      </svg>
                      <div
                        v-if="notifi.read !== true"
                        class="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full ring-2 ring-white"
                      ></div>
                    </div>

                    <div class="flex-1 min-w-0">
                      <p
                        class="text-xs truncate"
                        :class="{
                          'font-bold text-gray-900': notifi.read !== true,
                          'font-medium text-gray-600': notifi.read === true,
                        }"
                      >
                        {{ notifi.topic }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="flex items-center gap-3 flex-shrink-0 ml-11 sm:ml-0"
                  >
                    <p class="text-xs text-gray-600 whitespace-nowrap">
                      {{ formatDate(notifi.created_at) }}
                    </p>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-4 w-4 text-gray-300 group-hover:text-primary transition-colors"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <!-- No Notifications -->
            <p
              v-if="notificationList.length == 0"
              class="flex flex-col border-2 gap-1 py-4 px-5 rounded-xl text-center text-gray-500"
            >
              No Notifications
            </p>
          </div>
          <!-- Pagination -->
          <div
            v-if="notificationList.length > 0"
            class="flex justify-center py-4 space-x-2"
          >
            <Pagination
              ref="paginationRef"
              :totalPages="totalPages"
              @page-changed="fetchNotification"
            />
          </div>
        </div>

        <!-- ================= DETAIL VIEW ================= -->
        <div
          class="py-10 px-6"
          v-if="notificationIndex != null && selectNotificationData"
        >
          <!-- Back Button -->
          <button
            @click="triggerPage"
            class="bg-gray-700 hover:bg-gray-800 text-xs font-bold text-white px-5 py-1.5 rounded-full mb-3"
          >
            Back
          </button>

          <!-- Card -->
          <div class="border rounded-xl bg-white overflow-hidden">
            <div class="p-6">
              <h2 class="text-2xl font-bold text-gray-800 mb-3">
                {{ selectNotificationData.topic }}
              </h2>

              <div
                class="flex items-center gap-2 text-sm text-gray-500 mb-6 pb-4 border-b"
              >
                <svg
                  class="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                  />
                </svg>
                {{ formatDate(selectNotificationData.created_at) }}
              </div>

              <div class="bg-gray-50 rounded-lg p-5">
                <p class="text-gray-700 leading-relaxed">
                  {{ selectNotificationData.message }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import AdminHeader from "@/components/Admin/Header.vue";
import Footer from "@/components/Footer.vue";
import Pagination from "@/components/Pagination.vue";
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "Notifications",

  components: {
    Footer,
    AdminHeader,
    Pagination,
  },

  props: ["id"],

  data() {
    return {
      notificationIndex: null,
      selectNotificationData: null,
      currentPage: 1,
      totalPages: 1,
      total_count: 0,
      notificationList: [],
      notificationcount: null,
      student_email: "",
    };
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },

  created() {
    this.fetchNotification(1);
  },
  mounted() {
    this.student_email = decodeURIComponent(this.$route.params.email);
  },

  methods: {
    async fetchNotification(page) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/notifications/?received_user__id=${this.id}&Key=${this.userInfo.token_key}&page=${page}`,
        );

        if (response.data.data.status == 200) {
          this.notificationList = response.data.data.data;
          this.notificationcount = response.data.total;
          this.totalPages = response.data.total_page;
        }
      } catch (error) {
        console.error("Error fetching notifications:", error);
      }
    },

    setNotificationTab(index) {
      this.notificationIndex = index;
      this.selectNotificationData = this.notificationList[index];
    },

    triggerPage() {
      this.notificationIndex = null;
      this.selectNotificationData = null;
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);

      if (date.toDateString() === today.toDateString()) {
        return `Today, ${date.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        })}`;
      } else if (date.toDateString() === yesterday.toDateString()) {
        return `Yesterday, ${date.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        })}`;
      } else {
        return date.toLocaleDateString("en-IN", {
          day: "numeric",
          month: "short",
          year: "numeric",
        });
      }
    },
  },
};
</script>

<style scoped>
td,
thead,
tr {
  padding: 10px 20px;
  border: 1px solid black !important;
}

.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
